// app.quotes._index.tsx — the quotes list screen.
export const quotes = {
  pageHeading: "Quotes",
  importedBanner: {
    summaryOne: "Imported {{count}} quote",
    summaryOther: "Imported {{count}} quotes",
    skippedSuffix: " ({{count}} skipped due to errors)",
  },
  bulkCanceledBanner: {
    summaryOne: "Canceled {{count}} quote",
    summaryOther: "Canceled {{count}} quotes",
    skippedSuffix: " ({{count}} skipped — already in terminal state)",
  },
  actions: {
    newQuote: "New quote",
    bulkImport: "Bulk import from CSV",
    exportCsv: "Export filtered to CSV",
  },
  filter: {
    heading: "Filter",
    searchLabel: "Search number / company / buyer email / external ref",
    searchPlaceholder: "e.g. Q-12, Acme, alice@",
    companyGidLabel: "Company GID",
    fromLabel: "From (YYYY-MM-DD)",
    toLabel: "To (YYYY-MM-DD)",
    statusLabel: "Status",
    apply: "Apply filter",
    clear: "Clear",
  },
  emptyFiltered: {
    heading: "No quotes match those filters",
    body: "Try clearing or widening your filters to see more quotes.",
  },
  emptyNoQuotes: {
    heading: "No quotes yet",
    action: "Create your first quote",
    body: "Create your first quote and it will show up here.",
  },
  list: {
    headingOne: "{{total}} quote",
    headingOther: "{{total}} quotes",
    truncatedSuffix: " (showing first {{shown}})",
    selectAriaLabel: "Select {{number}} for bulk action",
    externalRef: "ext {{number}}",
    unknownCompany: "(unknown)",
    cancelSelected: "Cancel selected",
    cancelableHint: "Only DRAFT/SENT/VIEWED rows are checkable.",
    truncatedHint:
      "Narrow the filter (status, date range, company) to drill in. Pagination beyond the first 50 ships in a follow-up tick.",
  },
};
